module.exports = __webpack_public_path__ + "img/cxTrends-10.3af6955c.png";